import { LOGOUT } from "@/components/access/ducks/Actions"
import {
  DELETE_TASKS,
  EDIT_TASK,
  FETCH_TASKS,
  RECEIVE_TASKS,
  SAVE_TASK,
  TOGGLE_TASK_DRAWER_EDIT,
} from "@/components/tasks/admin/ducks/Actions"
import { UNMOUNT_TASK } from "@/components/tasks/ducks/Actions"

const defaultState = {
  loading: false,
  errorMessage: "",
  errorCount: 0,
  tasks: [],
  taskDrawerEdit: false,
  tasksFetched: false,
}

const adminTasksReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case LOGOUT:
      return defaultState

    case UNMOUNT_TASK:
      return {
        ...oldState,
        taskDrawerEdit: false,
        errorMessage: "",
        loading: false,
      }

    case RECEIVE_TASKS:
      return {
        ...oldState,
        tasks: action.tasks,
        tasksFetched: true,
        loading: false,
        errorMessage: "",
      }

    case FETCH_TASKS:
      return {
        ...oldState,
        tasksFetched: false,
      }

    case TOGGLE_TASK_DRAWER_EDIT:
      return {
        ...oldState,
        taskDrawerEdit: true,
      }

    case DELETE_TASKS:
      return {
        ...oldState,
        tasksFetched: false,
      }

    case SAVE_TASK:
      return {
        ...oldState,
        tasksFetched: false,
        loading: true,
        errorMessage: "",
      }
    case EDIT_TASK:
      return {
        ...oldState,
        loading: true,
        errorMessage: "",
      }

    default:
      return oldState
  }
}

export default adminTasksReducer
